export default "__VITE_ASSET__Cf7uDoSk__"